import { memo } from "react";

export const BlueBtn = memo(({ children }) => (
  <div className="relative inline-block">
    <div className="absolute top-[4px] left-[4px] w-full h-full bg-blue-100 z-0" />
    <button className="relative z-10 px-4 py-2 bg-primary-200 text-white font-medium">
      {children}
    </button>
  </div>
));
